/*
 * @Author: Huangxianlong
 * @Date: 2023-08-11 16:44:08
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2026-01-10 15:26:08
 * @FilePath: \monitor\src\language\project\zone.js
 * @Description: 
 */
const info = {
  CN: {
    newZone: "新建区域",
    editZone: "编辑区域",
    newCategory: "新建采集器类别",
    editCategory: "编辑采集器类别",
    cancelBtn: "取消",
    saveBtn: "保存",
    number: "序号",
    zoneId: "区域编号",
    zoneName: "区域名称",
    projectName: "项目名称",
    createTime: "创建时间",
    categoryId: "采集器类别",
    categoryType: "采集器类型",
    operation: "操作",
    edit: "编辑",
    delete: "删除",
    userProfile: "用户配置",
    tips: "温馨提示",
    deleteTips: "<p>该操作会将该区域下的采集器类别、采集器和传感器删除，请谨慎操作!</p><p>删除操作不可恢复，是否继续删除该区域？</p>",
    deleteTipsCategory: "删除操作不可恢复,是否继续删除该传感器类别？",
    deleteSuccess: "删除成功",
    deleteError: "删除失败",
    deleteCategoryError: "该类别下存在采集器不允许删除，请先删除该类别下的采集器",
    deleteZoneError: "该区域下存在采集器类别不允许删除，请先删除该区域下的采集器类别",
    validWarnText: "必填信息不能为空",
    addSuccess: "添加成功",
    addError: "添加失败",
    saveSuccess: "保存成功",
    saveError: "保存失败",
    userNotConfigured: "未配置用户",
    configuredUser: "已配置用户",
    alarmConfiguration: "告警配置",
    alarmTimeType: "告警方式",
    alarmTimeTypeRules: "告警方式不能为空",
    alarmTimeTypePla: "请选择告警方式",
    notificationMethod: "通知方式",
    notificationMethodRules: "通知方式不能为空",
    notificationMethodPla: "请选择通知方式",
    interval: "间隔（n分钟一次）",
    pointOfTime: "时间点（24小时制）",
    single: "单次（触发时发送一次）",
    disableTheAlarm: "关闭告警",
    timePointParameters: "告警时间点（多选）",
    mailbox: "邮箱",
    mailboxRules: "邮箱不能为空",
    mailboxPla: "请输入邮箱",
    textMessage: "短信",
    textMessageRules: "手机号码不能为空",
    textMessagePla: "请输入手机号码",
    mailboxTextMessage: "邮箱 + 短信",
    intervalParameter: "告警间隔（分钟）",
    intervalParameterRules: "告警间隔不能为空",
    timePointParametersRules: "告警时间点不能为空",
    intervalParameterPla: "请输入告警间隔",
    timePointParametersPla: "请选择告警时间点",
    canNotBeEmpty: "不能为空",
    pleaseEnter: "请输入",
    addMailbox: "添加邮箱",
    addPhoneNumber: "添加手机号码",
    delete: "删除",
    alarmTip: "首次超过阀值将立即触发告警，之后如果数值持续超过阀值，需要连续告警，可选间隔方式（固定间隔多久报警一次）和时间点方式（每天报警的时间点）。单次告警，只在触发时发出告警。",
    alarmIntervalSetting: "告警间隔设置",
    offlineAlarmSettings: "离线告警设置",
    alarmEmailSetting: "告警邮箱设置",
    mailboxTip: "邮箱最多添加10个",
    alarmTextMessageSetting: "告警手机号码设置",
    textMessageTip: "手机号码最多添加10个",
    offlineAlarmCycle: "离线周期数（超过时告警）",
    offlineAlarmCycleRules: "离线周期数不能为空",
    offlineAlarmCyclePla: "请输入离线周期数",
    phoneNumber: "手机号码",
  },
  EN: {
    newZone: "New Zone",
    editZone: "Edit Zone",
    newCategory: "New Category",
    editCategory: "Edit Category",
    cancelBtn: "Cancel",
    saveBtn: "Save",
    number: "Number",
    zoneId: "Zone Id",
    zoneName: "Zone Name",
    projectName: "Project Name",
    createTime: "Create Time",
    categoryId: "Category Id",
    categoryType: "Category Type",
    operation: "Operations",
    edit: "edit",
    delete: "delete",
    userProfile: "user profile",
    tips: "Tips",
    // deleteTips: "The deletion operation is not recoverable. Do you want to continue deleting this zone?",
    deleteTips: "This operation will delete the collector categories and dataloggers and sensors under this zone. Please proceed with caution.</p><p>The deletion cannot be recovered. Are you sure you want to delete this zone?</p>",
    deleteTipsCategory: "The deletion operation is irreversible. Do you want to continue deleting this sensor category?",
    deleteSuccess: "Successfully deleted",
    deleteError: "Delete failed",
    deleteCategoryError: "There are dataloggers in this category that cannot be deleted. Please delete the dataloggers in this category first",
    deleteZoneError: "There are datalogger categories in this zone that cannot be deleted. Please delete the datalogger category in this zone first",
    validWarnText: "Required information cannot be empty",
    addSuccess: "Added successfully",
    addError: "Add failed",
    saveSuccess: "Successfully saved",
    saveError: "Save failed",
    userNotConfigured: "User not configured",
    configuredUser: "Configured user",
    alarmConfiguration: "Alarm configuration",
    pointOfTime: "point of time（24-hour clock system）",
    interval: "interval（Once every n minutes）",
    alarmTimeType: "Alarm method",
    alarmTimeTypeRules: "The alarm method type cannot be empty",
    alarmTimeTypePla: "Please select the type of alarm method",
    notificationMethod: "Notification method",
    notificationMethodRules: "The notification method type cannot be empty",
    notificationMethodPla: "Please select the type of notification method",
    timePointParameters: "Alarm time point (multiple choice)",
    intervalParameter: "Alarm interval（minutes）",
    intervalParameterRules: "The alarm interval cannot be empty",
    timePointParametersRules: "Alarm time point cannot be empty",
    mailbox: "Email",
    mailboxRules: "Email cannot be empty",
    mailboxPla: "Please enter your email address",
    textMessage: "Text message",
    textMessageRules: "Mobile phone number cannot be empty",
    textMessagePla: "Please enter your phone number",
    mailboxTextMessage: "Email + Text message",
    intervalParameterPla: "Please enter the alarm interval",
    timePointParametersPla: "Please select the alarm time point",
    canNotBeEmpty: " can not be empty",
    pleaseEnter : "Please enter ",
    addMailbox: "Add mailbox",
    addPhoneNumber: "Add phone number",
    delete: "Delete",
    alarmTip: "The first time the threshold is exceeded, an alert will be triggered immediately. If the value continues to exceed the threshold, consecutive alerts are required, with optional interval modes (fixed intervals for how often to alert) and time-point modes (specific times to alert daily). For single alerts, the alert is issued only when triggered.",
    alarmIntervalSetting: "Alarm interval setting",
    offlineAlarmSettings: "Offline alarm settings",
    alarmEmailSetting: "Alarm email setting",
    mailboxTip: "Add up to 10 email addresses",
    alarmTextMessageSetting: "Alarm phone number setting",
    textMessageTip: "Add up to 10 mobile phone numbers",
    offlineAlarmCycle: "Number of offline cycles (alarm when exceeded)",
    offlineAlarmCycleRules: "The number of offline cycles cannot be empty",
    offlineAlarmCyclePla: "Please enter the number of offline cycles",
    single: "Single (sent once upon triggering)",
    disableTheAlarm: "Disable the alarm",
    phoneNumber: "Phone number",
  }
};
export default info;



// WEBPACK FOOTER //
// ./src/language/project/zone.js